import { useLanguage } from '@/context/LanguageContext';
import { usePublicConfig } from '@/hooks/usePublicConfig';

export function useCustomLabels() {
  const { language, t } = useLanguage();
  const { config } = usePublicConfig();

  const getLabel = (key: string, fallbackKey?: string) => {
    const customLabels = config.button_labels?.[language];
    
    if (customLabels && customLabels[key]) {
      return customLabels[key];
    }
    
    // Fallback to translation system
    return t(fallbackKey || key);
  };

  return { getLabel };
}